import {
  ActionSheetController,
  AlertController,
  App,
  Events,
  IonicPage,
  LoadingController, ModalController,
  NavController
} from 'ionic-angular';
import {AlertServiceProvider} from '../../services/alert-service/alert-service';
import {Component} from '@angular/core';
import {ConfigServiceProvider} from '../../services/config-service/config-service';
import {LogoutService} from '../../../../shared/services/logout.service';
import {PlayerServiceProvider} from '../../services/player-service/player-service';
import {StorageServiceProvider} from '../../services/storage-service/storage-service';
import {TextServiceProvider} from '../../services/text-service/text-service';
import {HttpClient} from '@angular/common/http';
import {CameraService} from "../../services/camera-service/camera-service";
import {SellionsTakePhoto} from "../../../../shared/components/sellions-take-photo/sellions-take-photo";
import {ENVIRONMENT} from "../../../../../environments/environment";

@IonicPage()
@Component({
  selector: 'page-settings',
  templateUrl: 'settings.html',
})
export class SettingsPage {
  error: boolean;
  placeholderPassword: string;
  placeholderNewPassword: string;
  placeholderRepeatNewPassword: string;

  password: any = {
    old: '',
    new: '',
    repeat: '',
  };
  loading;
  user: any = {name: '', image: null, password: ''};
  player: any = {};
  image;
  codePush;

  constructor(
    public actionSheetCtrl: ActionSheetController,
    public configService: ConfigServiceProvider,
    public navCtrl: NavController,
    public textService: TextServiceProvider,
    private alertCtrl: AlertController,
    private alertService: AlertServiceProvider,
    private app: App,
    private events: Events,
    private http: HttpClient,
    private loadingCtrl: LoadingController,
    private logoutService: LogoutService,
    private playerService: PlayerServiceProvider,
    private storageService: StorageServiceProvider,
    private cameraService: CameraService,
    private modalCtrl: ModalController
  ) {
    this.events.subscribe('player:photoChanged', () => {
      this.loadPlayer();
    });
  }

  ngOnInit() {
    this.loadPlayer();
    this.storageService.get('codePushVersion')
      .then(res => this.codePush = res)
      .catch(err => {
        console.error(err);
        this.codePush = '';
      });
    this.placeholderPassword = this.textService.get('settingsOldPasswordPlaceholder') || 'Podaj stare hasło';
    this.placeholderNewPassword = this.textService.get('settingsNewPasswordPlaceholder') || 'Podaj nowe hasło';
    this.placeholderRepeatNewPassword = this.textService.get('settingsNewRepeatPasswordPlaceholder') || 'Powtórz nowe hasło';

  }

  loadPlayer() {
    this.playerService.getPlayer().then(response => this.player = response);
  }

  takePhoto() {
    this.takeAndChangePhoto(1);
  }

  selectPhoto() {
    this.takeAndChangePhoto(0);
  }

  private takeAndChangePhoto(sourceType: number) {
    if (this.cameraService.canTakePhoto() || sourceType === 0) {
      const modal = this.modalCtrl.create(SellionsTakePhoto, {sourceType});
      modal.onDidDismiss(data => {
        if (data) {
          this.changePhoto(data);
        }
      });
      modal.present();
    } else {
      this.showCameraError();
    }
  }

  changePhoto(image): void {
    this.loading = this.loadingCtrl.create({
      content: this.textService.get('settingsSendingMessage')
    });
    this.loading.present();

    this.playerService.changePhoto(image)
      .then(() => {
        this.player.photo = '';
        this.loadPlayer();
        this.loading.dismiss();
      }).catch((err) => {
      this.alertService.showNoConnAlert(() => {
      });
      this.loading.dismiss();
    });
  }

  showCameraError() {
    this.alertService.showErrorAlert(this.textService.get('settingsNoCameraError'));
  }

  photoManagement(): void {
    let actionSheet = this.actionSheetCtrl.create({title: 'Zdjęcie profilowe', enableBackdropDismiss: true});
    actionSheet.addButton({
      text: 'Zrób nowe',
      icon: 'camera',
      handler: () => {
        this.takePhoto();
      }
    });
    actionSheet.addButton({
      text: "Wybierz zdjęcie z urządzenia",
      icon: 'image',
      handler: () => {
        this.selectPhoto();

      }
    });
    if (this.player.photo) {
      actionSheet.addButton({
        text: 'Usuń zdjęcie',
        icon: 'trash',
        handler: () => {
          this.playerService.deletePhoto().catch(err => {
            this.alertService.showNoConnAlert(() => {
            });
          })
        }
      })
    }
    actionSheet.present()
      .catch(err => {
        console.error(err);
      });

  }


  logout(): void {
    this.alertCtrl.create(({
      title: 'Wyloguj',
      message: 'Czy na pewno chcesz się wylogować?',
      // cssClass: 'alert-wrapper',
      buttons: [
        {
          text: 'Nie',
          role: 'cancel'
        },
        {
          text: 'Tak',
          handler: () => {
            this.logoutService.logout()
          }
        }
      ]
    })).present();
  }

  sync() {
    this.storageService.flushCache();
    this.http.post(this.configService.getUrl('synchronize'), {}).subscribe();
    this.app.getRootNav().setRoot('LoadingPage').catch(err => console.error(err));
  }

  changePassword() {
    this.loading = this.loadingCtrl.create({
      content: this.textService.get('settingsSendingMessage')
    });
    this.loading.present();

    if (this.password.new !== this.password.repeat) {
      this.alertService.showErrorAlert(this.textService.get('settingsWrongPasswords'));
      this.loading.dismiss();
    } else {
      this.playerService.changePassword(this.password.old, this.password.new)
        .then(() => {
          this.loading.dismiss();
          this.alertService.showInfoAlert(this.textService.get('settingsPasswordChanged'), this.textService.get('settingsChangePassword')).then(() => {
            this.password.old = '';
            this.password.new = '';
            this.password.repeat = '';
          });
        }).catch(reason => {
        let subTitle;
        if (reason.error.message === 'wrong_old_password') {
          subTitle = this.textService.get('settingsActualPassError');
        } else if (reason.error.message === 'wrong_new_password_format') {
          subTitle = this.textService.get('settingsLengthPassError');
        } else {
          subTitle = undefined;
        }

        this.loading.dismiss();
        if (reason.status === 0) {
          this.alertService.showNoConnAlert(() => this.changePassword());
        } else {
          this.alertService.showErrorAlert(subTitle);
        }
      });
    }
  }

  showLoadingError() {
    this.alertCtrl.create({
      title: 'Błąd',
      subTitle: 'Podczas ładowania wystapił nieoczekiwany błąd.',
      buttons: [
        {
          text: 'OK'
        }
      ]
    }).present();
  }

  showTypeError() {
    this.alertCtrl.create({
      title: 'Błąd',
      subTitle: 'Wybrany format pliku nie jest obsługiwany.',
      buttons: [
        {
          text: 'OK'
        }
      ]
    }).present();
  }

  goToKeycloakPanel(): void {
    window.open(ENVIRONMENT.authServerBaseUrl + 'auth/realms/' + ENVIRONMENT.authRealm + '/account/#/personal-info', '_blank').focus();
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/pages/settings/settings.ts